@if (viewState().showAuthenticating) {

    <mat-card>
        <mat-card-content>
            Authenticating user...
        </mat-card-content>
        <mat-card-footer>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </mat-card-footer>
    </mat-card>

}

@if (viewState().showRoutes) {
    @if (invitations.lookupError()) {
    <mat-card class="mb-4">
        <mat-card-content>
            <p role="alert">Shared billing invitations could not be checked. You can continue using the app and retry.</p>
            <button matButton type="button" (click)="invitations.retry()">Retry invitation check</button>
        </mat-card-content>
    </mat-card>
    }
    <router-outlet></router-outlet>
}








